export const IS_ANDROID_WEB_VIEW = !!(window as any).SUPAndroid;
export const IS_F_DROID_APP = !!(window as any).SUPFDroid;
